"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _TrContext = require("./TrContext");

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _reactHtmlParser = require("react-html-parser");

var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);

var _nodeToolbox = require("@esnpm/node-toolbox");

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require("react-router-dom");

var _TranslationMultipleRegister = require("../actions/TranslationMultipleRegister");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// import withTrMethods from "../factories/withTrMethods";

var TrProvider = (_temp = _class = function (_React$Component) {
	_inherits(TrProvider, _React$Component);

	function TrProvider(props, context) {
		_classCallCheck(this, TrProvider);

		var _this = _possibleConstructorReturn(this, (TrProvider.__proto__ || Object.getPrototypeOf(TrProvider)).call(this, props, context));

		_this.state = {
			activeLanguage: props.activeLanguage,
			availableLanguages: props.availableLanguages
		};
		return _this;
	}

	_createClass(TrProvider, [{
		key: "getActiveLanguage",
		value: function getActiveLanguage() {
			return this.state.activeLanguage;
		}
	}, {
		key: "setActiveLanguage",
		value: function setActiveLanguage(language_code) {
			this.setState({
				activeLanguage: language_code
			});
		}
	}, {
		key: "trmExists",
		value: function trmExists(trm) {
			var _this2 = this;

			return _lodash2.default.min(trm.pathesToCheck.map(function (path) {
				return _lodash2.default.has(_this2.props.tr.allTranslations, path);
			}));
		}
	}, {
		key: "registerMultipleTranslation",
		value: function registerMultipleTranslation(trm) {
			var _this3 = this;

			this.props.dispatch((0, _nodeToolbox.action_once)(function () {
				return !_this3.trmExists(trm);
			}, (0, _TranslationMultipleRegister.translationMultipleRegister)(trm)));
		}
	}, {
		key: "getTranslation",
		value: function getTranslation(path, options) {
			var text = this.tr(path, options);
			text = this.prepareText(text, options);
			var parts = this.generateParts(text, options);

			return parts.map(function (part) {
				return part;
			});

			// return this.tr(path);
		}
	}, {
		key: "tr",
		value: function tr(path, options) {
			var defaultOptions = {
				stripHtml: false,
				limit: 0,
				excerptSuffix: "...",
				trExcerptSuffix: "",
				activeLanguage: this.state.activeLanguage
			};

			options = Object.assign({}, defaultOptions, options);
			var tr = this.props.tr;
			// const {tr, activeLanguage = tr.activeLanguage} = this.props;

			var activeLanguage = options.activeLanguage;

			if (tr == null) {
				return '';
			}

			path = _lodash2.default.toPath(path);
			path = path.join(".");

			var deep_value = _lodash2.default.get(tr.allTranslations, path, null);

			if (deep_value === null) return '';

			var ret = _lodash2.default.get(deep_value, activeLanguage, null);

			//Kopie der available Languages machen + all hinzufügen
			var availableLanguages = [];
			this.state.availableLanguages.map(function (LC) {
				availableLanguages.push(LC);
			});
			availableLanguages.unshift("ALL");

			var LANGUAGES = availableLanguages;
			LANGUAGES = LANGUAGES.filter(function (el) {
				return el !== activeLanguage;
			});
			LANGUAGES.unshift(activeLanguage);

			//die erste passende übersetzung raussuchen
			LANGUAGES.some(function (lang) {
				ret = _lodash2.default.get(deep_value, lang, null);
				return ret !== null;
			});

			if (ret != null) {
				if (options.stripHtml) {
					ret = this.stripHtml(ret);
				}
				if (options.limit > 0) {
					ret = this.excerpt(ret, options.limit, options.excerptSuffix, options.trExcerptSuffix);
				}
			}

			return !ret ? "" : ret;
		}
	}, {
		key: "stripHtml",
		value: function stripHtml(text) {
			var tmp = document.createElement('div');
			tmp.innerHTML = text;
			return tmp.textContent || tmp.innerHTML;
		}
	}, {
		key: "excerpt",
		value: function excerpt(text, limit, excerptSuffix, trExcerptSuffix) {
			var suffix = trExcerptSuffix === '' ? excerptSuffix : this.tr(trExcerptSuffix);

			if (text.length <= limit) {
				return text;
			} else {
				return text.substr(0, text.lastIndexOf(' ', limit)) + ' ' + suffix;
			}
		}
	}, {
		key: "prepareText",
		value: function prepareText(text, options) {
			var limit = options.limit,
			    stripHtml = options.stripHtml,
			    format = options.format;


			if (stripHtml) {
				text = this.stripHtml(text);
			}

			if (limit > 0) {
				text = this.excerpt(text, limit, this.props.excerptSuffix, this.props.trExcerptSuffix);
			}

			return text;
		}
	}, {
		key: "replaceCurlyBrakets",
		value: function replaceCurlyBrakets(text) {
			var replCurlyOpen = /{{/g;
			var replCurlyClose = /}}/g;
			return text.replace(replCurlyOpen, '{').replace(replCurlyClose, '}');
		}
	}, {
		key: "generateParts",
		value: function generateParts(text, options) {
			var reVals = /{(.[a-zA-Z0-9_-]*)}/g;
			var reRemoveCurlyBrackets = /{|}/gi;

			var html = options.html,
			    component = options.component,
			    format = options.format;


			var matches = text.match(reVals);
			if (matches == null) {

				var _item = this.replaceCurlyBrakets(text);
				if (html) {
					return [_react2.default.createElement(
						_react.Fragment,
						{ key: 1 },
						(0, _reactHtmlParser2.default)(_item)
					)];
				} else if (component != null) {
					return [_react2.default.cloneElement(component, _extends({}, component.props, {
						source: _item,
						key: 1
					}))];
				} else {
					return [_item];
				}
			}

			var piped = matches.join('|');
			var rePiped = new RegExp(piped, 'g');
			var splitted = text.split(rePiped);

			var ret = [];
			var item = null;
			var keyText = 0;
			var keyVal = 0;

			for (var i = 0; i < splitted.length; i++) {
				keyText = i * 2;
				// keyVal = (i * 2) + 1;
				// Text
				item = this.replaceCurlyBrakets(splitted[i]);
				if (html) {
					ret.push(_react2.default.createElement(
						_react.Fragment,
						{ key: keyText },
						(0, _reactHtmlParser2.default)(item)
					));
				} else if (component != null) {
					return [_react2.default.cloneElement(component, _extends({}, component.props, {
						source: item,
						key: 1
					}))];
				} else {

					// kein HTML
					keyVal++;
					ret.push(_react2.default.createElement(
						_react.Fragment,
						{ key: keyVal },
						item
					));
				}
				// Value
				if (format != null && matches[i] != undefined) {

					item = matches[i].replace(reRemoveCurlyBrackets, '');
					var arrayEntry = format[item];

					if (arrayEntry != null) {
						keyVal++;

						if (Array.isArray(arrayEntry)) {
							arrayEntry = Object.entries(arrayEntry).map(function (_ref) {
								var _ref2 = _slicedToArray(_ref, 2),
								    loop = _ref2[0],
								    entry = _ref2[1];

								return _react2.default.cloneElement(entry, { key: loop });
							});
						}

						ret.push(_react2.default.createElement(
							_react.Fragment,
							{ key: keyVal },
							arrayEntry
						));
					}
				}
			}
			return ret;
		}
	}, {
		key: "render",
		value: function render() {
			var contextData = _extends({
				registerMultipleTranslation: this.registerMultipleTranslation.bind(this),
				getTranslation: this.getTranslation.bind(this),
				allTranslations: this.props.tr.allTranslations,
				setActiveLanguage: this.setActiveLanguage.bind(this),
				trmExists: this.trmExists.bind(this),
				tr: this.tr.bind(this)
			}, this.state);

			return _react2.default.createElement(
				_TrContext.TrContext.Provider,
				{ value: contextData },
				this.props.children
			);
		}
	}]);

	return TrProvider;
}(_react2.default.Component), _class.propTypes = {
	activeLanguage: _propTypes2.default.string,
	availableLanguages: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
}, _temp);


TrProvider.displayName = "TrProvider";

exports.default = (0, _redux.compose)(_reactRouterDom.withRouter, (0, _reactRedux.connect)(function (state) {
	return { tr: state.tr };
}))(TrProvider);